import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {factsheetsPageText as factsheetsPageText_en} from "../libs/en/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_en_ca} from "../libs/en-ca/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_de} from "../libs/de/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_de_ch} from "../libs/de-ch/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_fr} from "../libs/fr/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_fr_fr} from "../libs/fr-fr/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_fr_ca} from "../libs/fr-ca/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_nl} from "../libs/nl/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_it} from "../libs/it/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_it_ch} from "../libs/it-ch/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_cz} from "../libs/cz/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_fi} from "../libs/fi/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_pl} from "../libs/pl/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_se} from "../libs/se/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_no} from "../libs/no/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_dk} from "../libs/dk/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_es} from "../libs/es/texts-factsheets-page-lib";
import {factsheetsPageText as factsheetsPageText_pt} from "../libs/pt/texts-factsheets-page-lib";
import parse from "html-react-parser";
import {GOOGLE_PLAY_APP_URL, APPLE_APP_STORE_URL} from "../utils/appStoreLinks";
import {Helmet} from 'react-helmet';
import {createGridSwipeHandlers} from '../utils/gridSwipeScroll';
import {isDanaOnlyResource, isDanaResourcesAvailable} from '../utils/language';

export class Factsheets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            language: this.props.language,
            factsheetsPageText: factsheetsPageText_en,
            prefix: '',
            activeFilter: 'ypso',
            sortBy: 'popular',
            currentSlide: 0,
            sortDropdownOpen: false
        };
        this.sortContainer = React.createRef();
        const gridSwipeHandlers = createGridSwipeHandlers(this);
        this.handleGridTouchStart = gridSwipeHandlers.onTouchStart;
        this.handleGridTouchEnd = gridSwipeHandlers.onTouchEnd;
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.nextSlide = this.nextSlide.bind(this);
        this.prevSlide = this.prevSlide.bind(this);
        this.downloadPdf = this.downloadPdf.bind(this);
        this.toggleSortDropdown = this.toggleSortDropdown.bind(this);
        this.handleSortClickOutside = this.handleSortClickOutside.bind(this);
        if (this.state.language === "DE") {
            this.state.factsheetsPageText = factsheetsPageText_de;
            this.state.prefix = '/de';
        }
        if (this.state.language === "DE-CH") {
            this.state.factsheetsPageText = factsheetsPageText_de_ch;
            this.state.prefix = '/de-ch';
        }
        if (this.state.language === "EN-CA") {
            this.state.factsheetsPageText = factsheetsPageText_en_ca;
            this.state.prefix = '/en-ca';
        }
        if (this.state.language === "FR-FR") {
            this.state.factsheetsPageText = factsheetsPageText_fr_fr;
            this.state.prefix = '/fr';
        }
        if (this.state.language === "FR") {
            this.state.factsheetsPageText = factsheetsPageText_fr;
            this.state.prefix = '/fr-ch';
        }
        if (this.state.language === "FR-CA") {
            this.state.factsheetsPageText = factsheetsPageText_fr_ca;
            this.state.prefix = '/fr-ca';
        }
        if (this.state.language === "NL") {
            this.state.factsheetsPageText = factsheetsPageText_nl;
            this.state.prefix = '/nl';
        }
        if (this.state.language === "IT") {
            this.state.factsheetsPageText = factsheetsPageText_it;
            this.state.prefix = '/it';
        }
        if (this.state.language === "IT-CH") {
            this.state.factsheetsPageText = factsheetsPageText_it_ch;
            this.state.prefix = '/it-ch';
        }
        if (this.state.language === "CZ") {
            this.state.factsheetsPageText = factsheetsPageText_cz;
            this.state.prefix = '/cz';
        }
        if (this.state.language === "FI") {
            this.state.factsheetsPageText = factsheetsPageText_fi;
            this.state.prefix = '/fi';
        }
        if (this.state.language === "PL") {
            this.state.factsheetsPageText = factsheetsPageText_pl;
            this.state.prefix = '/pl';
        }
        if (this.state.language === "SE") {
            this.state.factsheetsPageText = factsheetsPageText_se;
            this.state.prefix = '/se';
        }
        if (this.state.language === "NO") {
            this.state.factsheetsPageText = factsheetsPageText_no;
            this.state.prefix = '/nb';
        }
        if (this.state.language === "DK") {
            this.state.factsheetsPageText = factsheetsPageText_dk;
            this.state.prefix = '/dk';
        }
        if (this.state.language === "ES") {
            this.state.factsheetsPageText = factsheetsPageText_es;
            this.state.prefix = '/es';
        }
        if (this.state.language === "PT") {
            this.state.factsheetsPageText = factsheetsPageText_pt;
            this.state.prefix = '/pt';
        }
    }

    setLanguageVars() {
        if (this.state.language !== this.props.language) {
            if (this.props.language === "EN") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_en,
                    prefix: ''
                });
            }
            if (this.props.language === "DE") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_de,
                    prefix: '/de'
                });
            }
            if (this.props.language === "DE-CH") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_de_ch,
                    prefix: '/de-ch'
                });
            }
            if (this.props.language === "EN-CA") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_en_ca,
                    prefix: '/en-ca'
                });
            }
            if (this.props.language === "FR") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_fr,
                    prefix: '/fr-ch'
                });
            }
            if (this.props.language === "FR-CA") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_fr_ca,
                    prefix: '/fr-ca'
                });
            }
            if (this.props.language === "FR-FR") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_fr_fr,
                    prefix: '/fr'
                });
            }
            if (this.props.language === "NL") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_nl,
                    prefix: '/nl'
                });
            }
            if (this.props.language === "IT") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_it,
                    prefix: '/it'
                });
            }
            if (this.props.language === "IT-CH") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_it_ch,
                    prefix: '/it-ch'
                });
            }
            if (this.props.language === "CZ") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_cz,
                    prefix: '/cz'
                });
            }
            if (this.props.language === "FI") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_fi,
                    prefix: '/fi'
                });
            }
            if (this.props.language === "PL") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_pl,
                    prefix: '/pl'
                });
            }
            if (this.props.language === "SE") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_se,
                    prefix: '/se'
                });
            }
            if (this.props.language === "NO") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_no,
                    prefix: '/nb'
                });
            }
            if (this.props.language === "DK") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_dk,
                    prefix: '/dk'
                });
            }
            if (this.props.language === "ES") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_es,
                    prefix: '/es'
                });
            }
            if (this.props.language === "PT") {
                this.setState({
                    language: this.props.language,
                    factsheetsPageText: factsheetsPageText_pt,
                    prefix: '/pt'
                });
            }
        }
    }

    componentDidUpdate() {
        this.setLanguageVars();
        if (!isDanaResourcesAvailable(this.props.language) && this.state.activeFilter === 'dana') {
            this.setState({ activeFilter: 'ypso', currentSlide: 0 });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.addEventListener('mousedown', this.handleSortClickOutside);
        document.body.classList.remove('open-sort');
    }

    handleFilterChange(filter) {
        if (filter === 'dana' && !isDanaResourcesAvailable(this.state.language)) {
            return;
        }
        this.setState({ activeFilter: filter, currentSlide: 0 });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleSortClickOutside);
        document.body.classList.remove('open-sort');
    }

    handleSortClickOutside(event) {
        if (this.sortContainer.current && !this.sortContainer.current.contains(event.target)) {
            this.setState({ sortDropdownOpen: false });
            document.body.classList.remove('open-sort');
        }
    }

    downloadPdf(factsheet) {
        // Support both single pdfUrl and category-specific pdfUrls
        const pdfUrl = factsheet.pdfUrls
            ? factsheet.pdfUrls[this.state.activeFilter] || factsheet.pdfUrl
            : factsheet.pdfUrl;
        if (pdfUrl) {
            window.open(pdfUrl, '_blank');
        }
    }

    toggleSortDropdown() {
        this.setState(prevState => ({ sortDropdownOpen: !prevState.sortDropdownOpen }));
        document.body.classList.toggle('open-sort');
    }

    handleSortChange(sortValue) {
        this.setState({ sortBy: sortValue, sortDropdownOpen: false });
        document.body.classList.remove('open-sort');
    }

    nextSlide() {
        const filteredFactsheets = this.getFilteredFactsheets();
        const maxSlide = Math.max(0, Math.ceil(filteredFactsheets.length / 6) - 1);
        this.setState(prevState => ({
            currentSlide: prevState.currentSlide < maxSlide ? prevState.currentSlide + 1 : prevState.currentSlide
        }));
    }

    prevSlide() {
        this.setState(prevState => ({
            currentSlide: prevState.currentSlide > 0 ? prevState.currentSlide - 1 : 0
        }));
    }


    getFilteredFactsheets() {
        let factsheets = this.state.factsheetsPageText.factsheets || [];
        const danaAvailable = isDanaResourcesAvailable(this.state.language);
        const activeFilter = (!danaAvailable && this.state.activeFilter === 'dana')
            ? 'ypso'
            : this.state.activeFilter;

        if (!danaAvailable) {
            factsheets = factsheets.filter(factsheet => !isDanaOnlyResource(factsheet));
        }

        // Filter by category (supports both single category and categories array)
        if (activeFilter !== 'all') {
            factsheets = factsheets.filter(factsheet =>
                factsheet.categories
                    ? factsheet.categories.includes(activeFilter)
                    : factsheet.category === activeFilter
            );
        }
        
        // Sort factsheets
        if (this.state.sortBy === 'newest') {
            factsheets = [...factsheets].sort((a, b) => new Date(b.date) - new Date(a.date));
        } else if (this.state.sortBy === 'oldest') {
            factsheets = [...factsheets].sort((a, b) => new Date(a.date) - new Date(b.date));
        } else if (this.state.sortBy === 'a-z') {
            factsheets = [...factsheets].sort((a, b) => a.title.localeCompare(b.title));
        } else if (this.state.sortBy === 'popular') {
            factsheets = [...factsheets].sort((a, b) => (b.views || 0) - (a.views || 0));
        }
        
        return factsheets;
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.factsheetsPageText.title)}</title>
                    <meta name="title" content={parse(this.state.factsheetsPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.factsheetsPageText.descriptionMeta)}/>
                    <meta property="og:locale" content={this.state.factsheetsPageText.localeMeta}/>
                    <meta name="keywords" content={this.state.factsheetsPageText.keywords}/>
                </Helmet>
                <Header props={this.props}/>

                <section className="inner-banner user-training-page">
                    <div className="container">
                        <div className="justify-content-center">
                            <div className="user-training-header animations-page-header"  style={{width: '100%'}} >
                                <h1>{parse(this.state.factsheetsPageText.mainHeader)}</h1>
                                <p>{parse(this.state.factsheetsPageText.mainSubHeader)}</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Filter Bar */}
                <section className="animations-filter-section">
                    <div className="container-fluid animations-filter-container">
                        <div className="animations-filter-wrapper">
                            {/* Filter Buttons */}
                            <div className="animations-filter-buttons">
                                {/* YpsoPump Filter */}
                                <button
                                    onClick={() => this.handleFilterChange('ypso')}
                                    className={`animations-filter-btn ${this.state.activeFilter === 'ypso' ? 'active' : ''}`}
                                >
                                    {parse(this.state.factsheetsPageText.filterYpsoPump || 'YpsoPump')}
                                    {this.state.activeFilter === 'ypso' && (
                                        <div className="animations-filter-indicator"></div>
                                    )}
                                </button>
                                
                                {isDanaResourcesAvailable(this.state.language) && (
                                <button
                                    onClick={() => this.handleFilterChange('dana')}
                                    className={`animations-filter-btn ${this.state.activeFilter === 'dana' ? 'active' : ''}`}
                                >
                                    {parse(this.state.factsheetsPageText.filterDana || 'Dana')}
                                    {this.state.activeFilter === 'dana' && (
                                        <div className="animations-filter-indicator"></div>
                                    )}
                                </button>
                                )}
                            </div>
                            
                            {/* Sort Dropdown - Matching Language Dropdown Style */}
                            <div className="animations-sort-dropdown" ref={this.sortContainer}>
                                <div className={`animations-sort-label ${this.state.sortDropdownOpen ? 'open-sort' : ''}`}>
                                    <input 
                                        type="checkbox" 
                                        id="sort-toggle"
                                        onClick={this.toggleSortDropdown}
                                    />
                                    <label htmlFor="sort-toggle">
                                        {this.state.sortBy === 'newest' ? (this.state.factsheetsPageText.sortNewest || 'Newest') :
                                         this.state.sortBy === 'oldest' ? (this.state.factsheetsPageText.sortOldest || 'Oldest') :
                                         this.state.sortBy === 'a-z' ? (this.state.factsheetsPageText.sortAZ || 'A-Z') :
                                         (this.state.factsheetsPageText.sortPopular || 'Most popular')}
                                    </label>
                                    {this.state.sortDropdownOpen && (
                                        <div className="animations-sort-list">
                                            <ul>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('newest');
                                                        }}
                                                        className={this.state.sortBy === 'newest' ? 'active' : ''}
                                                    >
                                                        {this.state.factsheetsPageText.sortNewest || 'Newest'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('oldest');
                                                        }}
                                                        className={this.state.sortBy === 'oldest' ? 'active' : ''}
                                                    >
                                                        {this.state.factsheetsPageText.sortOldest || 'Oldest'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('a-z');
                                                        }}
                                                        className={this.state.sortBy === 'a-z' ? 'active' : ''}
                                                    >
                                                        {this.state.factsheetsPageText.sortAZ || 'A-Z'}
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            this.handleSortChange('popular');
                                                        }}
                                                        className={this.state.sortBy === 'popular' ? 'active' : ''}
                                                    >
                                                        {this.state.factsheetsPageText.sortPopular || 'Most popular'}
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Factsheets Grid Slider */}
                <section className="animations-grid-section">
                    <div className="container-fluid animations-grid-container">
                        {/* Previous Button */}
                        {(() => {
                            const isDisabled = this.state.currentSlide === 0;
                            return (
                                <button
                                    onClick={this.prevSlide}
                                    className={`animations-nav-button animations-nav-prev ${isDisabled ? 'disabled' : ''}`}
                                    disabled={isDisabled}
                                    aria-label={this.state.factsheetsPageText.ariaPrevSlide || "Previous slide"}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 18L9 12L15 6" stroke="#04ABA0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            );
                        })()}
                        
                        {/* Next Button */}
                        {(() => {
                            const filteredFactsheets = this.getFilteredFactsheets();
                            const maxSlide = Math.max(0, Math.ceil(filteredFactsheets.length / 6) - 1);
                            const isDisabled = this.state.currentSlide >= maxSlide;
                            return (
                                <button
                                    onClick={this.nextSlide}
                                    className={`animations-nav-button animations-nav-next ${isDisabled ? 'disabled' : ''}`}
                                    disabled={isDisabled}
                                    aria-label={this.state.factsheetsPageText.ariaNextSlide || "Next slide"}
                                >
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="#04ABA0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            );
                        })()}
                        
                        {/* Factsheets Grid */}
                        <div
                            className="animations-grid-slider-wrapper"
                            onTouchStart={this.handleGridTouchStart}
                            onTouchEnd={this.handleGridTouchEnd}
                        >
                            <div 
                                className="animations-grid-slider"
                                style={{ transform: `translateX(-${this.state.currentSlide * 100}%)` }}
                            >
                                {(() => {
                                    const filteredFactsheets = this.getFilteredFactsheets();
                                    const slides = [];
                                    for (let i = 0; i < filteredFactsheets.length; i += 6) {
                                        slides.push(filteredFactsheets.slice(i, i + 6));
                                    }
                                    return slides.map((slideFactsheets, slideIndex) => (
                                        <div key={slideIndex} className="animations-grid-slide">
                                            {slideFactsheets.map((factsheet, index) => (
                                                <div key={index} className="animations-video-card factsheet-card">
                                                    {/* Factsheet Image */}
                                                    <div 
                                                        className="animations-video-thumbnail-wrapper factsheet-image-wrapper"
                                                        onClick={() => this.downloadPdf(factsheet)}
                                                    >
                                                        <img
                                                            src={factsheet.image}
                                                            alt={factsheet.title}
                                                            className="animations-video-thumbnail image-icon"
                                                        />
                                                    </div>
                                                    <h3 className="animations-video-title">
                                                        {parse(factsheet.title)}
                                                    </h3>

                                                    {/* Factsheet Info
                                                    <div className="animations-video-info">
                                                        <h3 className="animations-video-title">
                                                            {parse(factsheet.title)}
                                                        </h3>
                                                        <p className="animations-video-meta">
                                                            {factsheet.date}
                                                        </p>
                                                        <p className="animations-video-description">
                                                            {parse(factsheet.description)}
                                                        </p>
                                                    </div> */}
                                                    
                                                    {/* Divider Line */}
                                                    <div className="animations-video-divider"></div>
                                                </div>
                                            ))}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>

                        {/* Pagination Dots */}
                        {(() => {
                            const filteredFactsheets = this.getFilteredFactsheets();
                            const totalSlides = Math.ceil(filteredFactsheets.length / 6);
                            if (totalSlides > 1) {
                                return (
                                    <div className="animations-pagination">
                                        {Array.from({ length: totalSlides }, (_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => this.setState({ currentSlide: index })}
                                                className={`animations-pagination-dot ${this.state.currentSlide === index ? 'active' : ''}`}
                                                aria-label={(this.state.factsheetsPageText.ariaGoToSlide || "Go to slide {n}").replace("{n}", String(index + 1))}
                                            />
                                        ))}
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </div>
                </section>

                {/* Getting Started Section */}
                <section className="getting-started-section">
                    <div className="container-lg">
                        <div className="row">
                            {/* Left Column */}
                            <div className="col-12 col-lg-6">
                                {/* Title */}
                                <h2>{parse(this.state.factsheetsPageText.gettingStartedHeader || 'Ready to get started?')}</h2>

                                {/* Step 1 */}
                                <div className="getting-started-step">
                                    <h3 className="step-title">
                                        <p>{parse(this.state.factsheetsPageText.step1Title || '<strong>Step 1:</strong> Download the app')}</p>
                                    </h3>
                                    <div className="logo-container">
                                        <a href={GOOGLE_PLAY_APP_URL} 
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/google-play-badge.png" 
                                                 alt={this.state.factsheetsPageText.altGooglePlay || "Get it on Google Play"} />
                                        </a>
                                        <a href={APPLE_APP_STORE_URL} 
                                           target="_blank" 
                                           rel="noopener noreferrer">
                                            <img src="/images/app-store.png" 
                                                 alt={this.state.factsheetsPageText.altAppStore || "Download on App Store"} />
                                        </a>
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div className="getting-started-step step-2">
                                    <h3>
                                        <p>{parse(this.state.factsheetsPageText.step2Title || '<strong>Step 2:</strong> Create an account')}</p>
                                    </h3>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div className="col-12 col-lg-6">
                                {/* Step 3 */}
                                <div className="getting-started-step step-3">
                                    <h3>
                                        <p>{parse(this.state.factsheetsPageText.step3Title || '<strong>Step 3:</strong> Begin the in-app essential training')}</p>
                                    </h3>
                                </div>

                                {/* Step 4 */}
                                <div className="getting-started-step step-4">
                                    <h3>
                                        <p>
                                            {parse(this.state.factsheetsPageText.step4Title || '<strong>Step 4:</strong> Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>')}
                                            <span className="tooltip-wrapper">
                                                <span className="tooltip-container">
                                                    <img 
                                                        src="/images/info-circle.svg" 
                                                        alt={this.state.factsheetsPageText.altInfo || "Info"}
                                                        className="tooltip-icon"
                                                    />
                                                    <span className="tooltip-text">
                                                        {parse(this.state.factsheetsPageText.virtualModeTooltipText || 'Virtual mode allows you to trial the app without being connected to a real insulin pump and CGM sensor.')}
                                                    </span>
                                                </span>
                                            </span>
                                        </p>
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Support Section */}
                <section className="support-section">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            {/* Help Icon */}
                            <div className="col-12 col-md-auto d-flex justify-content-center justify-content-md-start">
                                <img 
                                    src="/images/help-icon.svg" 
                                    alt={this.state.factsheetsPageText.altHelp || "Help"}
                                    className="help-icon"
                                />
                            </div>

                            {/* Text Content */}
                            <div className="col-12 col-md">
                                <h3 style={{ marginBottom: '8px', lineHeight: '1.171875' }}>
                                    {parse(this.state.factsheetsPageText.supportSectionTitle || 'Need more help?')}
                                </h3>
                                <p style={{ margin: '0', lineHeight: '1.171875' }}>
                                    {parse(this.state.factsheetsPageText.supportSectionText || 'Our support team is here to assist you with any questions.')}
                                </p>
                            </div>

                            {/* Support Button */}
                            <div className="col-12 col-md-auto d-flex justify-content-center justify-content-md-end">
                                <a 
                                    href={this.state.prefix + "/support"}
                                    className="support-button support-button-rounded"
                                >
                                    {parse(this.state.factsheetsPageText.supportButtonText || 'CONTACT SUPPORT')}
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                
                <Footer props={this.props}/>
            </div>
        );
    }
}

